import { IEnv } from "../../../shared/interfaces/IEnv";

export default {
    client: {
        name: "faxinal",
        nomePrefeitura: "Prefeitura Municipal de Faxinal",
        logo: "https://d1cge5fflrvk0g.cloudfront.net/faxinal/logos/brasao_faxinal.png",
        brasao: "https://d1cge5fflrvk0g.cloudfront.net/faxinal/logos/logo_faxinal.png",
        municipio: "| FAXINAL - PR",
    },
    webgeo: {
        coordinatesPattern: "EPSG:32722",
        bci: {
            nomeSecretaria: "Divisão de Tributação",
        },
        confrontante: {
            informacoesRodape:
                "Av. Brasil, 694 - Faxinal, PR, 86840-000, Brasil (43) 3461-8010",
            nomeSecretaria: "Divisão de Tributação",
        },
        consultaPrevia: {
            nomeSecretaria: "Divisão de Tributação",
            contact: {
                email: "xxx",
                endereco: "Av. Brasil, 694",
                horarioAtendimento: "xxx",
                telefone: "(43) 3461-8010",
            },
            leiUsoDeSolo:
                "PARÂMETROS DE USO DO SOLO - Anexo (X) - Lei no XXXX/XXXX",
            leiVagasDeEstacionamento:
                "VAGAS PARA ESTACIONAMENTO anexo à lei XXXX/XXXXX",
        },
        config: {
            bci: true,
            confrontante: true,
            consultaPrevia: false,
            iptu: false,
            laws: false,
        },
        map: {
            center: [-51.3261756, -24.0021701],
            zoom: 18,
        },
    },
    api: {
        url: "https://api-staging.semv.com.br/",
    },
    geoserver: {
        url: process.env.REACT_APP_MIGRATION
            ? "https://geoserver-migration.semv.com.br/geoserver"
            : "https://geoserversp.semv.com.br/geoserver",
        ortoUrl: "https://geoserversp.semv.com.br/geoserver",
    },
} as IEnv;
